import { render } from "./QuestionAddPage.vue?vue&type=template&id=7a2b6538&scoped=true"
import script from "./QuestionAddPage.vue?vue&type=script&lang=js"
export * from "./QuestionAddPage.vue?vue&type=script&lang=js"

import "./QuestionAddPage.vue?vue&type=style&index=0&id=7a2b6538&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2b6538"]])

export default __exports__